// src/components/actionDashboard/common/CoverageTableHeader.tsx
import { FC } from "react";

type CoverageTableHeaderProps = {
  headers: { label: string }[];
};

const CoverageTableHeader: FC<CoverageTableHeaderProps> = ({ headers }) => {
  return (
    <thead className="sticky-top z-1">
      {/* <tr>
        <th colSpan={7}></th>
        <th className="colspan-head text-center" colSpan={1}>
          Medical Coverage (Buy & Bill)
          <span className="border"></span>
        </th>
        <th className="colspan-head text-center" colSpan={1}>
          Pharmacy Coverage (Speciality Pharmacy)
          <span className="border"></span>
        </th>
        <th className="colspan-head text-center" colSpan={2}>
          Actions
          <span className="border"></span>
        </th>
      </tr> */}
      <tr className="text-center">
        {headers.map((tableHeader, index) => (
          <th
            key={index}
            //className={`${[7, 8, 9, 10].includes(index) ? "colspan-head" : ""}`}
          >
            {tableHeader.label}
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default CoverageTableHeader;
